<template>
	<div class="agencyContestPanelView">
		<router-link :to="{ path: 'main-data'}" replace>
			<v-btn>Parametry naboru</v-btn>
		</router-link>
		<router-link :to="{ path: 'documents'}" replace>
			<v-btn>Dokumenty</v-btn>
		</router-link>
		<router-link :to="{ path: 'tasks'}" replace>
			<v-btn>Zadania</v-btn>
		</router-link>
		<router-link :to="{ path: 'constant-fields'}" replace>
			<v-btn>Pola stałe</v-btn>
		</router-link>
		<router-link :to="{ path: 'forms'}" replace>
			<v-btn>Formularze</v-btn>
		</router-link>
		<router-link :to="{ path: 'users'}" replace>
			<v-btn>Użytkownicy naboru</v-btn>
		</router-link>
		<router-link :to="{ path: 'teams'}" replace>
			<v-btn>Zespoły</v-btn>
		</router-link>
		<router-link :to="{ path: 'rating-settings'}" replace>
			<v-btn>Parametry oceny</v-btn>
		</router-link>
		<router-link :to="{ path: 'action'}" replace>
			<v-btn>Akcja</v-btn>
		</router-link>
		<router-view/>
	</div>
</template>

<script>
	export default {
		name: "AgencyContestPanelView",

    methods: {
      updateNames (name, shortName) {
        this.$parent.updateNames(name, shortName);
      }
    },
	};
</script>

<style scoped>
	a {
		color: #fff !important;
	}
</style>
